import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import moment from 'moment';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import DateInputPicker4 from 'modules/common/components/DateInputPicker4';
import useFormValidator from 'useFormValidator';
import * as actions from '../action';
import * as c from '../constant';

function OrdinanceRevisionModal({
  createOrdinanceRevision,
  updateOrdinanceRevision,
  getOrdinanceRevisionList,
  history,
  getSingleOrdinanceRevision,
  type,
  id,
  updateList,
}) {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    revision_indicator: '',
    year_from: '',
    year_to: '',
    is_present: true,
  });
  const validateForm = useFormValidator(formData, {
    name: 'required',
    description: 'required',
    revision_indicator: 'required|max_2_char',
    year_from: 'required',
    year_to: 'required',
  });
  const setModal = useContext(ModalContext);

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      name: _.get(formData, 'name').replace(/\s+/g, ' ').trim(),
      year_from: moment(_.get(formData, 'year_from')).format('YYYY'),
      year_to: _.get(formData, 'is_present')
        ? '2024'
        : moment(_.get(formData, 'year_to')).format('YYYY'),
    };

    if (type === 'NEW') {
      createOrdinanceRevision(args, ({ data }) => {
        setModal({ isOpen: false });
        getOrdinanceRevisionList();
        history.push(`/rpt/settings/ordinance-revisions/${_.get(data, 'id')}`);
        getSingleOrdinanceRevision(data.id);
      });
    }

    if (type === 'EDIT') {
      updateOrdinanceRevision(id, args, ({ data }) => {
        setModal({ isOpen: false });
        getOrdinanceRevisionList();
        getSingleOrdinanceRevision(id);
        history.push(`/rpt/settings/ordinance-revisions/${_.get(data, 'id')}`);
      });
    }
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const handleChangeInput = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: moment(e.target.value || new Date()).format('YYYY'),
    });
  };

  const onSetFormData = () => {
    if (!_.isEmpty(updateList)) {
      const yearFrom = moment(`${_.get(updateList, 'year_from')}`).format(
        'YYYY'
      );
      const yearTo = moment(`${_.get(updateList, 'year_to')}`).format('YYYY');
      const args = {
        ...updateList,
        year_from: yearFrom,
        year_to: yearTo,
        is_present: yearTo === moment(new Date()).format('YYYY')
      };
      setFormData(_.pick(args, _.keys(c.FORM_DATA)));
    }
  };

  useEffect(() => {
    if (type === 'NEW') {
      setFormData({
        name: '',
        description: '',
        revision_indicator: '',
        year_from: moment(new Date()).format('YYYY'),
        year_to: moment(new Date()).format('YYYY'),
      });
    }
    if (type === 'EDIT') {
      onSetFormData();
    }
  }, []);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Name {validateForm.renderMessage('name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="name"
              onChange={onChange}
              value={_.get(formData, 'name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Description {validateForm.renderMessage('description')}
            </label>
            <input
              className="form-control"
              type="text"
              name="description"
              onChange={onChange}
              value={_.get(formData, 'description')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Revision Indicator{' '}
              {validateForm.renderMessage('revision_indicator')}
            </label>
            <input
              className="form-control"
              type="text"
              name="revision_indicator"
              onChange={onChange}
              value={_.get(formData, 'revision_indicator') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="full-label mb-0">
              Year From: {validateForm.renderMessage('year_from')}
            </label>
            <DateInputPicker4
              onChange={handleChangeInput('year_from')}
              value={_.get(formData, 'year_from') || ''}
              showYearPicker
              dateFormat="yyyy"
              addClassName="ordinance-date"
              maxDate={new Date(_.get(formData, 'year_to'))}
              type="modal-input"
            />
          </div>
          {_.get(formData, 'is_present') === false ? (
            <div className="col-12 form-group">
              <label className="full-label mb-0">
                Year To: {validateForm.renderMessage('year_to')}
              </label>
              <DateInputPicker4
                onChange={handleChangeInput('year_to')}
                value={_.get(formData, 'year_to') || ''}
                showYearPicker
                dateFormat="yyyy"
                addClassName="ordinance-date"
                minDate={new Date(_.get(formData, 'year_from'))}
                type="modal-input"
              />
            </div>
          ) : (
            ''
          )}
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Present: &nbsp;
            </label>
            <input
              name="is_present"
              type="checkbox"
              checked={_.get(formData, 'is_present')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={!validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

OrdinanceRevisionModal.defaultProps = {
  type: '',
  id: '',
  updateList: {},
};

OrdinanceRevisionModal.propTypes = {
  getOrdinanceRevisionList: PropTypes.instanceOf(Function).isRequired,
  createOrdinanceRevision: PropTypes.instanceOf(Function).isRequired,
  updateOrdinanceRevision: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleOrdinanceRevision: PropTypes.instanceOf(Function).isRequired,
  type: PropTypes.string,
  id: PropTypes.string,
  updateList: PropTypes.instanceOf(Object),
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(OrdinanceRevisionModal);
